import React from "react";

function NoImageIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 24 24"
    >
      <g fill="#aaa">
        <path
          d="M3.38 20.85c-.21 0-.43-.09-.57-.27-1.07-1.25-1.56-3.03-1.56-5.58V9c0-5.43 2.32-7.75 7.75-7.75h6c2.39 0 4.14.45 5.38 1.38a.75.75 0 01-.9 1.2c-.97-.73-2.43-1.08-4.48-1.08H9C4.39 2.75 2.75 4.39 2.75 9v6c0 2.15.39 3.66 1.2 4.62.27.32.23.79-.09 1.06-.14.11-.31.17-.48.17z"
          data-original="#000000"
        ></path>
        <path
          d="M15 22.75H9c-.79 0-1.5-.05-2.15-.14-.41-.06-.69-.44-.63-.85s.45-.69.85-.63c.57.08 1.22.13 1.93.13h6c4.61 0 6.25-1.64 6.25-6.25V9c0-.33-.01-.66-.03-.96a.752.752 0 111.5-.1c.02.34.03.69.03 1.06v6c0 5.43-2.32 7.75-7.75 7.75zm-7-12c-1.52 0-2.75-1.23-2.75-2.75S6.48 5.25 8 5.25 10.75 6.48 10.75 8 9.52 10.75 8 10.75zm0-4a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"
          data-original="#aaaaaa"
        ></path>
        <path
          d="M2 22.75c-.19 0-.38-.07-.53-.22a.754.754 0 010-1.06l20-20c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-20 20c-.15.15-.34.22-.53.22z"
          data-original="#000000"
        ></path>
        <path
          d="M11.98 17.43c-.39 0-.78-.15-1.07-.44s-.29-.77 0-1.06.77-.29 1.06 0c.01.01.02.01.03 0l5.03-5.04c1.04-1.04 2.85-1.04 3.88 0l1.63 1.63c.29.29.29.77 0 1.06s-.77.29-1.06 0l-1.63-1.63c-.47-.47-1.29-.47-1.76 0l-5.03 5.04c-.3.29-.69.44-1.08.44z"
          data-original="#aaaaaa"
        ></path>
      </g>
    </svg>
  );
}

export default NoImageIcon;
